import { oofDtos } from '@vectronic/openApi-customer';

type UpdateOrderData = Pick<
  oofDtos.OofOrder,
  | 'invoiceAddress'
  | 'deliveryAddress'
  | 'displayInformationalDatepickers'
  | 'useOldIridiumPlans'
  | 'mainContact'
  | 'secondaryContact'
  | 'customerAccountEmail'
  | 'status'
  | 'paymentMethod'
  | 'purchaseOrderNo'
  | 'eInvoicing'
  | 'pickUpOrder'
  | 'comments'
>;

export type UpdateOrder = {
  orderId: oofDtos.OofOrder['id'];
  data: Partial<UpdateOrderData>;
  sendNotification?: boolean;
};

export function isAssignedToCustomer(order: oofDtos.Order): boolean {
  return !!order.customerAccountEmail;
}
